import styles from "./style.module.scss";

import DynamicForm from "@mavichpe/dynamic-forms";
import ChangeProductPartidaArancelariaFormConfig from "./form";
import { ProductPartidaArancelariaDataType } from "@/formTypes/ProductPartidaArancelariaDataType";

type ChangeProductPartidaArancelariaFormProps = {
  onPartidaChanged: (data: ProductPartidaArancelariaDataType) => void,
  defaultData: ProductPartidaArancelariaDataType,
  innerForm?: boolean
}

const ChangeProductPartidaArancelariaForm = (props: ChangeProductPartidaArancelariaFormProps) => {
  const { onPartidaChanged, innerForm = false, defaultData } = props;

  const onSubmit = (formData: ProductPartidaArancelariaDataType) => {
    if (onPartidaChanged) {
      onPartidaChanged(formData)
    }
  }

  return (
    <>
      <DynamicForm<ProductPartidaArancelariaDataType>
        externalFormState={defaultData}
        innerForm={innerForm}
        formConfig={ChangeProductPartidaArancelariaFormConfig}
        onSubmit={onSubmit}
      >
      </DynamicForm>
    </>

  )
}

export default ChangeProductPartidaArancelariaForm;